import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useId, useState } from "react";
import classnames from "classnames";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { useLogger } from "../../services/hooks/index.js";
import { Typography } from "../../Typography/index.js";
import { Box } from "../../Box/index.js";
import { ClearButton, Label, Preloader } from "../common/index.js";
import ReactInputMask from "../../ReactInputMask/index.js";
import { ShowPasswordButton } from "./ShowPasswordButton.js";
import TextInput_styles from "./TextInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TextInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TextInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const EXCLUDED_INPUT_NUMBER_KEYS = [
    'e',
    'E'
];
const handleOnWheel = (e)=>e.preventDefault();
const TextInput = (t0)=>{
    const $ = c(108);
    let autocomplete;
    let id;
    let inputFilter;
    let inputMode;
    let label;
    let labelIcon;
    let mask;
    let maxLength;
    let maxRows;
    let minLength;
    let onBlur;
    let onChange;
    let onFocus;
    let onKeyPress;
    let placeholder;
    let rest;
    let t1;
    let t10;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    let warning;
    if ($[0] !== t0) {
        ({ id, type: t1, label, labelIcon, value, placeholder, inputFilter, onChange, onFocus, onBlur, onKeyPress, tooltip: t2, mask, error: t3, helperText: t4, required: t5, disabled: t6, loading: t7, multiline: t8, clearable: t9, testId, rows: t10, maxRows, inputMode, autocomplete, warning, maxLength, minLength } = t0), rest = _object_without_properties(t0, [
            "id",
            "type",
            "label",
            "labelIcon",
            "value",
            "placeholder",
            "inputFilter",
            "onChange",
            "onFocus",
            "onBlur",
            "onKeyPress",
            "tooltip",
            "mask",
            "error",
            "helperText",
            "required",
            "disabled",
            "loading",
            "multiline",
            "clearable",
            "testId",
            "rows",
            "maxRows",
            "inputMode",
            "autocomplete",
            "warning",
            "maxLength",
            "minLength"
        ]);
        $[0] = t0;
        $[1] = autocomplete;
        $[2] = id;
        $[3] = inputFilter;
        $[4] = inputMode;
        $[5] = label;
        $[6] = labelIcon;
        $[7] = mask;
        $[8] = maxLength;
        $[9] = maxRows;
        $[10] = minLength;
        $[11] = onBlur;
        $[12] = onChange;
        $[13] = onFocus;
        $[14] = onKeyPress;
        $[15] = placeholder;
        $[16] = rest;
        $[17] = t1;
        $[18] = t10;
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
        $[27] = testId;
        $[28] = value;
        $[29] = warning;
    } else {
        autocomplete = $[1];
        id = $[2];
        inputFilter = $[3];
        inputMode = $[4];
        label = $[5];
        labelIcon = $[6];
        mask = $[7];
        maxLength = $[8];
        maxRows = $[9];
        minLength = $[10];
        onBlur = $[11];
        onChange = $[12];
        onFocus = $[13];
        onKeyPress = $[14];
        placeholder = $[15];
        rest = $[16];
        t1 = $[17];
        t10 = $[18];
        t2 = $[19];
        t3 = $[20];
        t4 = $[21];
        t5 = $[22];
        t6 = $[23];
        t7 = $[24];
        t8 = $[25];
        t9 = $[26];
        testId = $[27];
        value = $[28];
        warning = $[29];
    }
    const type = void 0 === t1 ? "text" : t1;
    const tooltip = void 0 === t2 ? null : t2;
    const error = void 0 === t3 ? false : t3;
    const helperText = void 0 === t4 ? "" : t4;
    const required = void 0 === t5 ? false : t5;
    const disabled = void 0 === t6 ? false : t6;
    const loading = void 0 === t7 ? false : t7;
    const multiline = void 0 === t8 ? false : t8;
    const clearable = void 0 === t9 ? false : t9;
    const rows = void 0 === t10 ? 1 : t10;
    const { classes } = TextInput_styles();
    const [showPassword, setShowPassword] = useState(false);
    const logger = useLogger();
    const reactId = useId();
    const inputId = null != id ? id : reactId;
    let t11;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>{
            setShowPassword(_temp);
        };
        $[30] = t11;
    } else t11 = $[30];
    const handleToggleShowPassword = t11;
    let t12;
    if ($[31] !== inputFilter || $[32] !== maxLength || $[33] !== onChange) {
        t12 = (e)=>{
            let newValue = e.target.value;
            if (inputFilter) {
                var _inputFilter;
                newValue = null != (_inputFilter = inputFilter(newValue)) ? _inputFilter : "";
            }
            if (maxLength && newValue) newValue = newValue.slice(0, maxLength);
            onChange(newValue);
        };
        $[31] = inputFilter;
        $[32] = maxLength;
        $[33] = onChange;
        $[34] = t12;
    } else t12 = $[34];
    const handleChange = t12;
    let t13;
    if ($[35] !== onFocus || $[36] !== type) {
        t13 = (event)=>{
            null == onFocus || onFocus(event);
            if ("number" === type) event.target.addEventListener("wheel", handleOnWheel);
        };
        $[35] = onFocus;
        $[36] = type;
        $[37] = t13;
    } else t13 = $[37];
    const handleOnFocus = t13;
    let t14;
    if ($[38] !== onBlur || $[39] !== type) {
        t14 = (event_0)=>{
            null == onBlur || onBlur(event_0);
            if ("number" === type) event_0.target.removeEventListener("wheel", handleOnWheel);
        };
        $[38] = onBlur;
        $[39] = type;
        $[40] = t14;
    } else t14 = $[40];
    const handleOnBlur = t14;
    let t15;
    if ($[41] !== onKeyPress || $[42] !== type) {
        t15 = (event_1)=>{
            null == onKeyPress || onKeyPress(event_1);
            if ("number" === type && EXCLUDED_INPUT_NUMBER_KEYS.includes(event_1.key)) event_1.preventDefault();
        };
        $[41] = onKeyPress;
        $[42] = type;
        $[43] = t15;
    } else t15 = $[43];
    const handleOnKeyPress = t15;
    let t16;
    if ($[44] !== helperText || $[45] !== (null == value ? void 0 : value.length) || $[46] !== warning) {
        t16 = (t17)=>{
            const { isError, text, warningText, maxInputLength, minInputLength } = t17;
            let lengthHelperText;
            if (minInputLength && maxInputLength) lengthHelperText = minInputLength === maxInputLength ? `Количество символов: ${minInputLength}` : `Допустимо от ${minInputLength} до ${maxInputLength} символов`;
            else if (minInputLength) lengthHelperText = `Минимальное количество символов: ${minInputLength}`;
            else if (maxInputLength) lengthHelperText = "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043E";
            const result = isError ? text : lengthHelperText || helperText;
            if (!isError && warningText) return /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "text.light.secondary",
                children: warning
            });
            if (result) return /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "caption",
                        color: isError ? "accent.text.error" : "text.light.secondary",
                        children: result
                    }),
                    (!isError || text === lengthHelperText) && maxInputLength && maxInputLength !== minInputLength && /*#__PURE__*/ jsx(Typography, {
                        variant: "caption",
                        color: isError ? "accent.text.error" : "text.light.secondary",
                        children: `${(null == value ? void 0 : value.length) || 0}/${maxInputLength}`
                    })
                ]
            });
            return helperText;
        };
        $[44] = helperText;
        $[45] = null == value ? void 0 : value.length;
        $[46] = warning;
        $[47] = t16;
    } else t16 = $[47];
    null == value || value.length;
    const renderHelperText = t16;
    let t17;
    let t18;
    if ($[48] !== autocomplete || $[49] !== logger || $[50] !== onChange) {
        t17 = ()=>{
            if ("OTPCredential" in window && "navigator" in window && "credentials" in window.navigator && "one-time-code" === autocomplete) {
                var _window_navigator_credentials, _window_navigator, _window;
                const ac = new AbortController();
                null == (_window = window) || null == (_window_navigator = _window.navigator) || null == (_window_navigator_credentials = _window_navigator.credentials) || _window_navigator_credentials.get({
                    otp: {
                        transport: [
                            "sms"
                        ]
                    },
                    signal: ac.signal
                }).then((otp)=>{
                    Promise.resolve(null == otp ? void 0 : otp.code).then((code)=>{
                        onChange(code);
                    });
                }).catch((e_0)=>{
                    if ("signal is aborted without reason" !== e_0.message) logger.error(e_0, {
                        tags: {
                            vkdoc_error_type: "webotp"
                        }
                    });
                });
                return ()=>{
                    ac.abort();
                };
            }
        };
        t18 = [
            autocomplete,
            logger,
            onChange
        ];
        $[48] = autocomplete;
        $[49] = logger;
        $[50] = onChange;
        $[51] = t17;
        $[52] = t18;
    } else {
        t17 = $[51];
        t18 = $[52];
    }
    useEffect(t17, t18);
    let t19;
    if ($[53] !== classes.clearButton || $[54] !== clearable || $[55] !== disabled || $[56] !== error || $[57] !== multiline || $[58] !== onChange || $[59] !== showPassword || $[60] !== type || $[61] !== value) {
        t19 = "password" === type ? /*#__PURE__*/ jsx(ShowPasswordButton, {
            isShow: showPassword,
            disabled: disabled,
            error: error,
            onClick: handleToggleShowPassword
        }) : !multiline && !disabled && clearable && value && /*#__PURE__*/ jsx(ClearButton, {
            className: classes.clearButton,
            onClick: ()=>onChange(""),
            color: error ? "error" : "disabled"
        });
        $[53] = classes.clearButton;
        $[54] = clearable;
        $[55] = disabled;
        $[56] = error;
        $[57] = multiline;
        $[58] = onChange;
        $[59] = showPassword;
        $[60] = type;
        $[61] = value;
        $[62] = t19;
    } else t19 = $[62];
    const buttons = t19;
    let t20;
    if ($[63] !== classes.textInput) {
        t20 = classnames(classes.textInput, "aqa_text_input");
        $[63] = classes.textInput;
        $[64] = t20;
    } else t20 = $[64];
    let t21;
    if ($[65] !== inputId || $[66] !== label || $[67] !== labelIcon || $[68] !== required || $[69] !== tooltip) {
        t21 = label && /*#__PURE__*/ jsx(Label, {
            label: label,
            required: required,
            tooltip: tooltip,
            icon: labelIcon,
            inputId: inputId
        });
        $[65] = inputId;
        $[66] = label;
        $[67] = labelIcon;
        $[68] = required;
        $[69] = tooltip;
        $[70] = t21;
    } else t21 = $[70];
    let t22;
    if ($[71] !== autocomplete || $[72] !== buttons || $[73] !== classes.adornedEnd || $[74] !== classes.input || $[75] !== disabled || $[76] !== error || $[77] !== handleChange || $[78] !== handleOnBlur || $[79] !== handleOnFocus || $[80] !== handleOnKeyPress || $[81] !== helperText || $[82] !== inputId || $[83] !== inputMode || $[84] !== label || $[85] !== loading || $[86] !== mask || $[87] !== maxLength || $[88] !== maxRows || $[89] !== minLength || $[90] !== multiline || $[91] !== onBlur || $[92] !== onFocus || $[93] !== onKeyPress || $[94] !== placeholder || $[95] !== renderHelperText || $[96] !== rest || $[97] !== rows || $[98] !== showPassword || $[99] !== testId || $[100] !== type || $[101] !== value || $[102] !== warning) {
        t22 = mask ? /*#__PURE__*/ jsx(ReactInputMask, _object_spread_props(_object_spread({}, rest), {
            mask: mask,
            value: value,
            onChange: handleChange,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyPress: onKeyPress,
            disabled: disabled || loading,
            children: /*#__PURE__*/ jsx(TextField, {
                id: inputId,
                name: rest.name,
                autoComplete: autocomplete || "off",
                inputMode: inputMode,
                "data-testid": testId,
                classes: {
                    root: classes.input
                },
                variant: "outlined",
                fullWidth: true,
                placeholder: placeholder || label,
                error: error,
                disabled: disabled || loading,
                slotProps: _object_spread({
                    input: {
                        className: "textFieldInput aqa_input",
                        classes: {
                            adornedEnd: classes.adornedEnd
                        },
                        endAdornment: loading ? /*#__PURE__*/ jsx(Preloader, {}) : buttons
                    }
                }, maxLength ? {
                    htmlInput: {
                        maxLength
                    }
                } : {}),
                helperText: renderHelperText({
                    isError: error,
                    text: helperText,
                    warningText: warning,
                    maxInputLength: maxLength,
                    minInputLength: minLength
                })
            })
        })) : /*#__PURE__*/ jsx(TextField, _object_spread_props(_object_spread({}, rest), {
            id: inputId,
            autoComplete: autocomplete || "off",
            "data-testid": testId,
            classes: {
                root: classes.input
            },
            type: showPassword ? "text" : type,
            inputMode: inputMode,
            value: loading && ("password" !== type || showPassword) ? "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." : value,
            onChange: handleChange,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            onKeyPress: handleOnKeyPress,
            variant: "outlined",
            fullWidth: true,
            placeholder: placeholder || label,
            error: error,
            disabled: disabled || loading,
            multiline: multiline,
            minRows: rows,
            maxRows: maxRows,
            slotProps: {
                input: {
                    id: inputId,
                    className: "textFieldInput aqa_input",
                    classes: {
                        adornedEnd: classes.adornedEnd
                    },
                    endAdornment: loading ? /*#__PURE__*/ jsx(Preloader, {}) : buttons
                }
            },
            helperText: renderHelperText({
                isError: error,
                text: helperText,
                warningText: warning,
                maxInputLength: maxLength,
                minInputLength: minLength
            })
        }));
        $[71] = autocomplete;
        $[72] = buttons;
        $[73] = classes.adornedEnd;
        $[74] = classes.input;
        $[75] = disabled;
        $[76] = error;
        $[77] = handleChange;
        $[78] = handleOnBlur;
        $[79] = handleOnFocus;
        $[80] = handleOnKeyPress;
        $[81] = helperText;
        $[82] = inputId;
        $[83] = inputMode;
        $[84] = label;
        $[85] = loading;
        $[86] = mask;
        $[87] = maxLength;
        $[88] = maxRows;
        $[89] = minLength;
        $[90] = multiline;
        $[91] = onBlur;
        $[92] = onFocus;
        $[93] = onKeyPress;
        $[94] = placeholder;
        $[95] = renderHelperText;
        $[96] = rest;
        $[97] = rows;
        $[98] = showPassword;
        $[99] = testId;
        $[100] = type;
        $[101] = value;
        $[102] = warning;
        $[103] = t22;
    } else t22 = $[103];
    let t23;
    if ($[104] !== t20 || $[105] !== t21 || $[106] !== t22) {
        t23 = /*#__PURE__*/ jsxs(FormControl, {
            className: t20,
            children: [
                t21,
                t22
            ]
        });
        $[104] = t20;
        $[105] = t21;
        $[106] = t22;
        $[107] = t23;
    } else t23 = $[107];
    return t23;
};
function _temp(prev) {
    return !prev;
}
export { TextInput };
